
seedWebApp.controller('EditAdminIntegrationCtrl', ['$scope', '$uibModal', '$document', '$window', '$timeout', 'IntegrationAdminService', 'TranslationService', '$routeParams', 'integrationID', '$uibModalInstance', 'IntegrationMonitorService', 'ToastService',
    function ($scope, $uibModal, $document, $window, $timeout, IntegrationAdminService, TranslationService, $routeParams, integrationID, $uibModalInstance, IntegrationMonitorService, ToastService) {

        $scope.integrationID = integrationID;
        console.log('EditAdminIntegrationCtrl');
        $scope.html = '';

        $scope.translation = TranslationService.getActiveTranslation();

        $scope.loadedItem = IntegrationAdminService.get({ id: $scope.integrationID, tabIndex: $routeParams.tab }, function (response) {
            $scope.listItem = response;
            console.log($scope.listItem);
        }, function errorFunc(errorDescription) {

        });

        $scope.openUibModal = function (templateUrl, size) {
            $uibModal.open({
                animation: true,
                templateUrl: templateUrl,
                size: size,
                resolve: {
                    colTargets: function () { return $scope.colTargets; },
                }
            });
            };


        $scope.execCommand = function () {
            $scope.loading = true;
            IntegrationAdminService.getList({ id: $scope.listItem.IntegrationID }, function (data) {
                $scope.loading = false;
                $scope.error = false;
                $scope.items = data;
            }, function errorFunc(errorDescription) {
                $scope.items = [];
                $scope.loading = false;
                $scope.error = true;
                $scope.errorDescription = errorDescription;
            });
        };

        $scope.getTargetTypes = function () {
            var list = [                
                {
                    "TargetName": "SAPMaterial",
                    "Display": "SAPMaterial"
                },
                {
                    "TargetName": "SAPMaterialSpec",
                    "Display": "SAPMaterialSpec"
                },
                {
                    "TargetName": "SAPContact",
                    "Display": "SAPContact"
                },
                {
                    "TargetName": "SAPContactPartner",
                    "Display": "SAPContactPartner"
                },
                {
                    "TargetName": "SAPContactSalesOrg",
                    "Display": "SAPContactSalesOrg"
                },
                {
                    "TargetName": "SAPSalesOrderUpdate",
                    "Display": "SAPSalesOrderUpdate"
                },
                {
                    "TargetName": "SAPSalesOrderSerial",
                    "Display": "SAPSalesOrderSerial"
                },
                {
                    "TargetName": "SAPStock",
                    "Display": "SAPStock"
                },
                
            ];
            return list;
        };

        $scope.pickListTargetTypes = $scope.getTargetTypes();        
        
        $scope.getSourceDataTypes = function () {
            var list = [
                //{ Value: 'CSV', Text: 'CSV' },
                //{ Value: 'JSON', Text: 'JSON' },
                //{ Value: 'XML', Text: 'XML' },
                { Value: 'IMP_ORDERS', Text: 'IMP_ORDERS' },
                { Value: 'IMP_POS', Text: 'IMP_POS' },
                { Value: 'IMP_STOCKS', Text: 'IMP_STOCKS' },
                { Value: 'RECALC_EXPIRED', Text: 'RECALC_EXPIRED' }
                //{ Value: 'SAP_CONTACT', Text: 'SAP_CONTACT' },
                //{ Value: 'SAP_MATERIAL', Text: 'SAP_MATERIAL (MUERTE)' },
                //{ Value: 'SAP_ORDER_UPDATE', Text: 'SAP_ORDER_UPDATE (MUERTE)' },
                //{ Value: 'SAP_ORDER_SERIAL', Text: 'SAP_ORDER_SERIAL (BR)' },
                //{ Value: 'SAP_CREATE_ORDER', Text: 'SAP_CREATE_ORDER' },
                //{ Value: 'SAP_STOCK', Text: 'SAP_STOCK (BR)' },
                //{ Value: 'SAGA_FORECAST_DATE', Text: 'SAGA_FORECAST_DATE' },
                //{ Value: 'SAGA_SYNC_ORDERS', Text: 'SAGA_SYNC_ORDERS' },
                //{ Value: 'SAGA_PRODUCTION', Text: 'SAGA_PRODUCTION' },
                //{ Value: 'SAP_UPDATE_ORDER_EDD', Text: 'SAP_UPDATE_ORDER_EDD' },
                //{ Value: 'SAGA_MATERIAL', Text: 'SAGA_MATERIAL' },
                // NOVAS GENESIS COLOMBIA
                //{ Value: "SAP_GET_MATERIAL_CARACT", Text: "SAP_GET_MATERIAL_CARACT" }, //SOMENTE CONFIGURACOES
                //{ Value: "SAP_CREATE_MATERIAL_ZFER", Text: "SAP_CREATE_MATERIAL_ZFER"},
                //{ Value: "SAP_CREATE_ENVOLVENTE", Text: "SAP_CREATE_ENVOLVENTE" },
            ];
            return list;
        };  
        $scope.pickListSourceDataType = $scope.getSourceDataTypes();

        
        $scope.getSourceTypes = function () {
            var list = [
                { Value: 'TEXT', Text: 'TEXT' },
                //{ Value: 'TABLE', Text: 'TABLE' },
                { Value: 'WEB_API', Text: 'WEB_API' }
            ];
            return list;
        };
        $scope.pickListSourceType = $scope.getSourceTypes();

        $scope.pickListContentType = [
            { Value: 'text/xml', Text: 'text/xml' },
            { Value: 'application/json', Text: 'application/json' }
        ];

        $scope.pickListDateModes = [
            { Value: 'Today', Text: 'Today' },
            { Value: 'Yesterday', Text: 'Yesterday' },
            //{ Value: 'PreviousStartDate', Text: 'PreviousStartDate' },
            { Value: 'PreviousEndDate', Text: 'PreviousEndDate' },
            { Value: 'OneWeek', Text: 'OneWeek' },
            { Value: 'OneMonth', Text: 'OneMonth' },
            { Value: 'ThreeMonths', Text: 'ThreeMonths' },
            { Value: 'SixMonths', Text: 'SixMonths' },
            { Value: 'OneYear', Text: 'OneYear' }
        ];

        $scope.colTargets = {
            Name: 'Targets',
            NameMany: 'Targets',
            FieldType: 'Grid',
            KeyFieldName: 'IntegrationID',
            Columns: [
                {
                    Name: 'ItemID',
                    Width: 50,
                    FieldType: 'Text',
                    //IsKey: true,
                },
                {
                    Name: 'TargetName',
                    FieldType: 'Picklist',
                    ColumnClass: 'col-md-3',
                    Picklist: $scope.getTargetTypes(),
                    NameDisplay: 'Display'
                },
                {
                    Name: 'TargetOptions',
                    FieldType: 'Memo',
                    ColumnClass: 'col-md-6',
                },
            ],
        }

        var dateMatchPattern = /^((0?[13578]|10|12)(-|\/)(([1-9])|(0[1-9])|([12])([0-9]?)|(3[01]?))(-|\/)((19)([2-9])(\d{1})|(20)([01])(\d{1})|([8901])(\d{1}))|(0?[2469]|11)(-|\/)(([1-9])|(0[1-9])|([12])([0-9]?)|(3[0]?))(-|\/)((19)([2-9])(\d{1})|(20)([01])(\d{1})|([8901])(\d{1})))$/;

        var convertDates = function (obj) {
            for (var key in obj) {
                if (!obj.hasOwnProperty(key)) {
                    continue;
                }

                var value = obj[key];
                var typeofValue = typeof (value);

                if (typeofValue === 'object') {
                    // If it is an object, check within the object for dates.
                    convertDates(value);
                } else if (typeofValue === 'string') {
                    if (dateMatchPattern.test(value)) {
                        obj[key] = new Date(value);
                    }
                }
            }
        };

        $scope.insertRowGrid2 = function (col, colName, scopeList, keyField, isCardEdit) {
            var numItems = $scope.getMaxId(scopeList[colName]);
            numItems++;

            //JRM: Tratar Parent Key
            var templateRow = {};

            var Item = 'ItemID';
            var Row = 'RowState';
            templateRow[keyField] = scopeList[keyField];
            templateRow[Item] = numItems;
            templateRow[Row] = 'New';

            for (var i in col.Columns) {
                var c = col.Columns[i];
                if (typeof (c.DefaultValue) !== 'undefined') {
                    templateRow[c.Name] = c.DefaultValue;
                }
            }

            if (typeof (templateRow) === 'object') {
                convertDates(templateRow);
            }
            scopeList[colName].push(templateRow);

            if (isCardEdit) {
                $scope.editTask(templateRow);
                $scope.afterInsertRow(templateRow, scopeList, colName, true);
            }
        };

        $scope.afterInsertRow = function (row, list, Name, shouldIncreaseOperNumber) {
            if (shouldIncreaseOperNumber) {
                //Incrementar o OperNumber
                var maxOperNumber = 0;
                var operations = list[Name];
                for (var i = 0; i < operations.length; i++) {
                    if (operations[i].OperNumber > maxOperNumber) {
                        maxOperNumber = operations[i].OperNumber;
                    }
                }
                maxOperNumber = parseInt(maxOperNumber) + 10;
                row.OperNumber = maxOperNumber;
            }
            row.Quantity = list.Quantity;
        };

        $scope.getMaxId = function (list) {
            var max = 0;
            if (!list) {
                return 0;
            }
            for (var i = 0; i < list.length; i++) {
                if (parseInt(list[i].ItemID, 10) > parseInt(max, 10)) {
                    max = list[i].ItemID;
                }
            }
            return max;
        };

        $scope.removeRowGrid = function (formEditing, item, scopeList, Name) {
            if (item.RowState === 'New') {
                var index = -1;
                var list = scopeList[Name];
                for (var i = 0; i < list.length; i++) {
                    if (list[i].ItemID === item.ItemID) {
                        index = i;
                    }
                }
                if (index >= 0) {
                    scopeList[Name].splice(index, 1);
                }
            }
            else if (item.RowState === 'Deleted') {
                $scope.undoRemoveRowGrid(formEditing, item);
            }
            else {
                item.RowState = 'Deleted';
                if (formEditing) {
                    formEditing.$setDirty();
                }
                $scope.stopEditing(item);
            }
        };

        $scope.undoRemoveRowGrid = function (formEditing, item) {
            if (item.RowState === 'Deleted') {
                item.RowState = 'Modified';
            }
        };

        $scope.stopEditing = function (item) {
            item.editing = false;
        };

        $scope.insertManyItems = function (colName, scopeList) {
            if (colName === 'Contacts') {
                var modalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: 'addManyItems.html',
                    controller: 'AddManyModalController',
                    size: 'md',
                    resolve: {
                        data: function () {
                            return scopeList;
                        }
                    }
                });
                modalInstance.result.then(function () {

                }, function () {
                    console.log('Error');
                });
                return modalInstance;
            }
        };

        $scope.getWindowHeight = function () {
            var innerHeight = Math.max(0, window.innerHeight);
            var headerHeight = 215;
            var height = innerHeight - headerHeight; //JRM: desconta header
            return height;
        };

        $document.ready(function () {
            console.log('document ready');
        });

        $scope.AdjustSize = function () {
            var innerHeight = Math.max(0, window.innerHeight);

            var headerHeight = 215;

            var height = innerHeight - headerHeight; //JRM: desconta header

            if (document.getElementById('SourceMappings')) {
                document.getElementById('SourceMappings').style.height = height + 'px';
            }
            if (document.getElementById('AfterDecodeScript')) {
                document.getElementById('AfterDecodeScript').style.height = height + 'px';
            }
            if (document.getElementById('Sample')) {
                document.getElementById('Sample').style.height = height + 'px';
            }

            if ($scope.myCodeMirror) {
                $scope.myCodeMirror.setSize(null, height);
                $scope.myCodeMirror.refresh();
            }
        }

        var w = angular.element($window);
        $scope.$watch(function () {
            return {
                'h': w.height(),
                'w': w.width()
            };
        }, function (newValue, oldValue) {
            $scope.windowHeight = newValue.h;
            $scope.windowWidth = newValue.w;
            $scope.AdjustSize();
        }, true);

        $scope.selectEditor = function (index) {
            var cmScript = $('.CodeMirror')[index].CodeMirror;
            var height = $scope.getWindowHeight();
            cmScript.setSize(null, height);
            $timeout(function () {
                cmScript.refresh();
            });
        };

        $scope.selectSourceConfig = function () {
            $scope.selectEditor(0);
        };

        $scope.selectSourceMappings = function () {
            $scope.selectEditor(1);
        };

        $scope.selectAfterDecodeScript = function () {
            $scope.selectEditor(2);
        };

        $scope.selectSample = function () {
            $scope.selectEditor(3);
        };

        $scope.ok = function () {
            //debugger;

            console.log('save');
            console.log($scope.listItem);

            $scope.loading = true;
            IntegrationAdminService.save($scope.listItem, function (data) {
                IntegrationAdminService.resetCache();
                $uibModalInstance.close();
            }, function (error) {
                $scope.loading = false;
                console.log('erro salvar');
                console.log(error);
                var msg = '';
                if (error.data && error.data.ExceptionMessage) {
                    msg = error.data.ExceptionMessage;
                }
                ToastService.createToast('Erro ao salvar', msg, 5000, 'error');  
            });
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.openDelete = function (integration) {
            var text = "a Integração " + integration.IntegrationName;
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'SPA/Shared/DeleteConfirmation.html',
                controller: 'DeleteConfirmationController',
                size: 'md',
                resolve: {
                    text: function () { return text; }
                }
            });

            modalInstance.result.then(function () {
                $scope.loadingDelete = true;
                $scope.deleteIntegration(integration.IntegrationID, function () {
                    $scope.loadingDelete = false;
                    $uibModalInstance.close('DELETE');
                });
            }, function () {
            });

        };

        $scope.deleteIntegration = function (id, callback) {
            IntegrationMonitorService.delete(id, callback);
        };

        $scope.addBody = function(item) {
            if (!item.Bodies) {
                item.Bodies = [];
            }
            var newBodie = {
                BodyRequest: '',
                RowState: 'New'
            };
            item.Bodies.push(newBodie);
        };


        IntegrationAdminService.getIntegrationGroups().then(function (response) {
            $scope.integrationGroups = response.data;
            //console.log(response);
        }, function errorFunc(errorDescription) {
            console.log('erro grupos');
        });


        $scope.editGroups = function () {
            console.log('editGroups');
        };

    }
]);
